import type { GetReleaseKitResponse } from '../../../../redux/api/fymAPI.types';
import type { PlanStepView } from '../../promote/releases/plan/rollout/rolloutModel';
import { fileHasWatermark } from './watermarkedFile';

/**
 * The draft posts of a rollout plan whose file carries the Music24 watermark: the count of the
 * warning next to "Schedule all" (design: trial-upsell a5). A step names its file
 * (`day.asset.assetUuid`): a kit asset or an AI reel of the release.
 */
export function watermarkedPlanDrafts(steps: ReadonlyArray<PlanStepView>, release: GetReleaseKitResponse): number {
  const assets = [...(release.ready ?? []), ...release.assets];
  return steps.reduce((sum, step) => {
    const uuid = step.day.asset?.assetUuid ?? null;
    if (uuid === null || step.day.skipped === true) {
      return sum;
    }
    const row = assets.find((one) => one.uuid === uuid) ?? release.reels.find((one) => one.uuid === uuid);
    if (!fileHasWatermark(row)) {
      return sum;
    }
    return sum + step.channels.filter((channel) => channel.post !== null && channel.post.status === 'draft').length;
  }, 0);
}
